/**
 * Short-TTL dedup for inbound pushes, keyed on the backend `hash` (falling back to
 * the message id). Suppresses the same logical notification being shown twice when
 * the transport retries or the same message is sent by mistake.
 */

const TTL_MS = 60_000
const MAX_ENTRIES = 200

// key -> expiry timestamp (ms)
const seen = new Map<string, number>()

export const PushDedup = {
  isDuplicate(key: string): boolean {
    if (!key) return false

    const now = Date.now()

    // Drop expired entries so the same key is allowed again after the window.
    for (const [k, expiresAt] of seen) {
      if (expiresAt <= now) seen.delete(k)
    }

    const existing = seen.get(key)
    if (existing != null && existing > now) {
      return true
    }

    seen.set(key, now + TTL_MS)

    // Bound memory: evict the oldest inserted key if we exceed the cap.
    if (seen.size > MAX_ENTRIES) {
      const oldest = seen.keys().next().value
      if (oldest !== undefined) seen.delete(oldest)
    }

    return false
  },

  /** Test isolation only. */
  reset(): void {
    seen.clear()
  },
}
